

































































import { Component, Vue } from 'vue-property-decorator';
import '../assets/css/SignUpPage.scss';
import { ObjectFactory } from '@/config/objectFactory';
import { MedTransGoConstants } from '@/util/constants';

@Component
export default class Updates extends Vue {
  private randomNumber = Math.floor(Math.random() * 9) + 1;

  private goToV3Portal() {
    window.location.href = process.env.VUE_APP_V3_PORTAL_URL || '';
  }

  private continueWithV2() {
    ObjectFactory.getCacheService().saveSessionValue(
      MedTransGoConstants.FIELD_STATE,
      '/',
    );
    const redirectUrl = `${this.$store.state.serverUrl}${MedTransGoConstants.HTTP_URL_LOGIN}?clientId=${this.$store.state.clientId}`;
    location.href = redirectUrl;
  }
}
